import React from 'react';

import badgeNotificationStyles from './BadgeNotification.scss';

export interface Props {
  name: string;
  imgSrc: string;
}

const BadgeNotificationIcon: React.FC<Props> = ({ name, imgSrc }) => (
  <div className={badgeNotificationStyles['icon-wrap']}>
    <img loading="lazy" alt={name} className={badgeNotificationStyles['icon']} src={imgSrc} />
  </div>
);
BadgeNotificationIcon.displayName = 'BadgeNotificationIcon';
export default BadgeNotificationIcon;
